<template>
    <div class="pr-1">
        <img src="@/assets/svg/edit-3.svg" alt="edit" class="edit" @click="goToUpdatePage">
    </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToUpdatePage () {
      this.$router.push({ path: `/settings/general/countries/edit/${this.row.id}` })
    }
  }
}
</script>

<style>
    .edit:hover {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/datatable/CountryEditButton.vue